import {
    getSessionStorageValue,
    isValidString,
    LOCAL_STORAGE_KEYS,
    setSessionStorageValue,
} from '../common/CommonUtilsMethods';
import type { PendingNewPasswordChallengeState } from './WorkyPendingNewPasswordChallengeInterfaces';

const storePendingNewPasswordChallengeState = (
    pendingNewPasswordChallengeState: PendingNewPasswordChallengeState
): void => {
    setSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_EMAIL,
        value: pendingNewPasswordChallengeState.emailAddress,
    });
    if (isValidString(pendingNewPasswordChallengeState.primaryWorkyCorpId)) {
        setSessionStorageValue({
            key: LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_PRIMARY_WORKY_CORP_ID,
            value: pendingNewPasswordChallengeState.primaryWorkyCorpId,
        });
        return;
    }
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_PRIMARY_WORKY_CORP_ID);
};

const readPendingNewPasswordChallengeState = (): PendingNewPasswordChallengeState | null => {
    const emailAddress: string = getSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_EMAIL,
    });

    if (!isValidString(emailAddress)) {
        return null;
    }

    const primaryWorkyCorpIdFromSession: string = getSessionStorageValue({
        key: LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_PRIMARY_WORKY_CORP_ID,
    });
    const primaryWorkyCorpId: string | null = isValidString(primaryWorkyCorpIdFromSession)
        ? primaryWorkyCorpIdFromSession.trim()
        : null;

    return {
        emailAddress: emailAddress.trim().toLowerCase(),
        primaryWorkyCorpId,
    };
};

const clearPendingNewPasswordChallengeState = (): void => {
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_EMAIL);
    sessionStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NEW_PASSWORD_PRIMARY_WORKY_CORP_ID);
};

export {
    clearPendingNewPasswordChallengeState,
    readPendingNewPasswordChallengeState,
    storePendingNewPasswordChallengeState,
};
